import styled from "styled-components";

const Divider = styled.div`
  height: 1px;
  background-color: #e6e6e6;
  width: 100%;
`;

export { Divider };
